import React, { useState, useEffect } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import "./App.css";

import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/auth";
import "firebase/compat/analytics";
import { useAuthState } from "react-firebase-hooks/auth";
// import { useCollectionData } from "react-firebase-hooks/firestore";

firebase.initializeApp({
	apiKey: "AIzaSyCVwUgUew8aMd5UjGLICGMaLY7F9qK3rYk",
	authDomain: "my-day-3e719.firebaseapp.com",
	projectId: "my-day-3e719",
	storageBucket: "my-day-3e719.appspot.com",
	messagingSenderId: "325708934038",
	appId: "1:325708934038:web:3e5f67a51c92bfdd640bb7",
	measurementId: "G-4E1K91PEYK",
});

const auth = firebase.auth();
const db = firebase.firestore();
// const analytics = firebase.analytics();

function App() {
	const [user] = useAuthState(auth);

	// useEffect(() => {
	// const userId = localStorage.getItem("mydayuid");
	// }, []);

	return (
		<div className="container">
			<div className="signout">{user ? <SignOut /> : ""}</div>

			{user ? <Entry /> : <SignIn />}
		</div>
	);
}

function SignIn() {
	const signInWithGoogle = () => {
		const provider = new firebase.auth.GoogleAuthProvider();
		auth.signInWithPopup(provider);
	};

	return (
		<>
			<button className="sign-in" onClick={signInWithGoogle}>
				Sign in with Google
			</button>
		</>
	);
}

function SignOut() {
	return (
		auth.currentUser && (
			<button className="sign-in" onClick={() => auth.signOut()}>
				Out
			</button>
		)
	);
}

function Entry() {
	const [markdown, setMarkdown] = useState("");

	const { uid } = auth.currentUser;

	useEffect(() => {
		getMessage();
	}, []);

	const getMessage = async () => {
		const docRef = db.collection("entries").doc(uid);
		docRef
			.get()
			.then((doc) => {
				if (doc.exists) {
					// console.log("Document data:", doc.data());
					setMarkdown(doc.data().text);
				} else {
					console.log("No such document!");
				}
			})
			.catch((error) => {
				console.log("Error getting document:", error);
			});
	};

	const sendMessage = async (msg) => {
		db.collection("entries")
			.doc(uid)
			.set({
				text: msg,
				// timestamp: firebase.firestore.FieldValue.serverTimestamp(),
			})
			.then(() => {
				console.log("Document successfully written!");
			})
			.catch((error) => {
				console.error("Error writing document: ", error);
			});
	};

	const handleChange = (e) => {
		setMarkdown(e.target.value);
		sendMessage(e.target.value);
	};

	return (
		<>
			<textarea value={markdown} onChange={handleChange} placeholder="Enter Markdown Here" />
			<ReactMarkdown
				children={markdown}
				remarkPlugins={[[remarkGfm, { singleTilde: false }]]}
				className="preview"
			/>
		</>
	);
}

export default App;
